import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const apiKeyInterceptor: HttpInterceptorFn = (req, next) => {
  // If the request targets our API URL, attach the x-api-key header
  if (req.url.startsWith(environment.apiUrl)) {
    const modifiedReq = req.clone({
      headers: req.headers.set('x-api-key', environment.apiKey)
    });
    return next(modifiedReq);
  }
  return next(req);
};
